/**
 * External dependencies
 */
import {
	ImageUploadPlaceholder, BackgroundSettings
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.info-section-2.edit.inspector.style.before', 'cartzillagb/info-section-2', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		displayTitle,
		displayDesc1,
		displayDesc2,
		displayImage,
		displayQrCode,
		enableBadge,
		backgroundColor,
		background,
	} = attributes


	return (

        <PanelBody title={ __( 'General Settings', i18n ) } initialOpen={ true }>
            <ToggleControl
                label={ __( 'Enable Container', i18n ) }
                checked={ enableContainer }
                onChange={ enableContainer => setAttributes( { enableContainer } ) }
            />

            <ToggleControl
                label={ __( 'Enable Badge', i18n ) }
                checked={ enableBadge }
                onChange={ enableBadge => setAttributes( { enableBadge } ) }
            />
            
            <ToggleControl
                label={ __( 'Display Title', i18n ) }
                checked={ displayTitle }
                onChange={ displayTitle => setAttributes( { displayTitle } ) }
            />

            <ToggleControl
                label={ __( 'Display Description 1', i18n ) }
                checked={ displayDesc1 }
                onChange={ displayDesc1 => setAttributes( { displayDesc1 } ) }
            />

            <ToggleControl
                label={ __( 'Display Description 2', i18n ) }
                checked={ displayDesc2 }
                onChange={ displayDesc2 => setAttributes( { displayDesc2 } ) }
            />

            <ToggleControl
                label={ __( 'Display Qr Code Image', i18n ) }
                checked={ displayQrCode }
                onChange={ displayQrCode => setAttributes( { displayQrCode } ) }
            />

            <ToggleControl
                label={ __( 'Display Image', i18n ) }
                checked={ displayImage }
                onChange={ displayImage => setAttributes( { displayImage } ) }
            />

            
            <ToggleControl
                label={ __( 'Display Image', i18n ) }
                checked={ displayImage }
                onChange={ displayImage => setAttributes( { displayImage } ) }
            />

            { enableBadge && 
				<BackgroundSettings
					background={ background }
					backgroundColor={ backgroundColor }
					onChangeBackground={ background => setAttributes( { background, backgroundColor: '' } ) }
					onChangeBackgroundColor={ backgroundColor => setAttributes( { backgroundColor:backgroundColor.hex, background: '' } ) }
					onRemoveBackground={ () => { setAttributes( { background: '', backgroundColor: '' } ) } }
					softBackground={ false }
				/>
			}

           

        </PanelBody>
            
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		displayTitle,
		displayDesc1,
		displayDesc2,
		displayImage,
		displayQrCode,
		enableBadge,
		badge,
		title,
		desc1,
		desc2,
		mediaURL,
		mediaURL1,
		backgroundColor,
		background,
	} = attributes

	const mainClasses = classnames( [
		className,
		'bg-secondary py-4',
		'info-section-2-block'
	], applyFilters( 'cartzillagb.info-section-2.main-block.classes', {}, props ) )

	const containerClasses = classnames( [
		' pt-4 pt-md-0',
		enableContainer ? 'container' : '',
	] )

	const bgStyle = { backgroundColor: backgroundColor && backgroundColor }
		
	return (
		<section className={ mainClasses }>
			<div className={ containerClasses }>
				<div className="row align-items-center">
					<div className="col-xl-4 offset-xl-1 col-lg-5 offset-lg-1 col-md-6 text-center text-md-left">

						{ enableBadge && 
							<RichText
								tagName='span'
								className={ `badge ${ backgroundColor ? '' : ( background ? background : 'bg-info' ) } font-size-sm mb-4` }
								value={ badge || 'From v1.2' }
								style={ bgStyle }
								onChange={ badge => setAttributes( { badge } ) }
								placeholder={ __( 'badge' ) }
								keepPlaceholderOnFocus
							/>
						}

						{ displayTitle && 
							<RichText
								tagName='h2'
								value={ title || '<span class="font-weight-light">Even More</span> Mobile Friendly <span class="font-weight-light">Interface</span>' }
								onChange={ title => setAttributes( { title } ) }
								placeholder={ __( 'title' ) }
								keepPlaceholderOnFocus
							/>
						}

						{ displayDesc1 && 
							<RichText
								tagName='p'
								className="text-muted pb-2"
								value={ desc1 || 'New <span class="font-weight-medium">Toolbar</span>  designed specifically for handheld devices to further improve user experience.' }
								onChange={ desc1 => setAttributes( { desc1 } ) }
								placeholder={ __( 'desc1' ) }
								keepPlaceholderOnFocus
							/>
						}

						{ displayDesc2 && 
							<RichText
								tagName='p'
								className="font-size-sm"
								value={ desc2 || 'Scan QR code below to test on your device:' }
								onChange={ desc2 => setAttributes( { desc2 } ) }
								placeholder={ __( 'desc2' ) }
								keepPlaceholderOnFocus
							/>
						}

						{ displayQrCode && 
							<ImageUploadPlaceholder
								imageURL={ mediaURL }
								onRemove={ () => {
									setAttributes( {
										mediaURL: '',
									} )
								} }
								onChange={ ( { url } ) => {
									setAttributes( {
										mediaURL: url,
									} )
								} }
								hasRemove={ false }
								render={ <img src={ mediaURL } width="150" alt={ __( 'QR code' ) } /> }
							/>
						}
					</div>
					{ displayImage && 
						<div className="col-md-6">
							<ImageUploadPlaceholder
								imageURL={ mediaURL1 }
								onRemove={ () => {
									setAttributes( {
										mediaURL1: '',
									} )
								} }
								onChange={ ( { url } ) => {
									setAttributes( {
										mediaURL1: url,
									} )
								} }
								hasRemove={ false }
								render={ <img src={ mediaURL1 } className="d-block mx-auto" alt={ __( 'Toolbar' ) } /> }
							/>
						</div>
					}
					
				</div>
			</div>
		</section>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )